export const utcNow = (): number => {
    return Math.round(new Date().getTime() / 1000);
};
